import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../../services/core.user.service';

@Component({
    selector: 'board-list-paging',
    template: `<div class="row">
    <div class="col-xs-12 col-md-12">

        <div class="btn-toolbar pull-left" role="toolbar" aria-label="Toolbar">
            <div *ngIf="canAdd" class="btn-group btn-group-sm">
                <button type="button" class="btn btn-success" aria-haspopup="true" (click)="addNew.emit(true)">
                    <i class="glyphicon glyphicon-plus"></i>
                    <span translate>New Board</span>
                </button>
            </div>
            <div class="btn-group btn-group-sm">
                <a class="btn btn-default" (click)="refresh.emit()">
                    <i class="glyphicon glyphicon-refresh" [ngClass]="{ 'el-pulse': !boards }"></i>
                    <span translate>Refresh</span>
                </a>
            </div>
        </div>

        <gf-pager [items]="boards" (onpage)="updatePaging.emit($event)"></gf-pager>
</div>`
})
export class BoardListPagingComponent implements OnInit {

    @Input() project: any = null;
    @Input() boards: any = null;
    @Input() queries: any = null;

    @Output() addNew: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() updatePaging: EventEmitter<any> = new EventEmitter<any>();
    @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected canAdd = false;

    constructor(
        private userService: UserService,
    ) { }
    
    ngOnInit() {
        this.canAdd = this.userService.hasUser();
    }
}